import moment from "moment";
import React, { useEffect, useState } from "react";
import axios from "../../config/axiosInstance";
import { useQuery, useQueryClient } from "react-query";
import { CopyBlock, dracula } from "react-code-blocks";
import { ADMIN, API } from "../../config/apiConfig";
import {
  Alert,
  Button,
  Timeline,
  TimelineBody,
  TimelineContent,
  TimelineItem,
  TimelinePoint,
  TimelineTime,
  TimelineTitle,
} from "flowbite-react";
import { AiOutlineLoading } from "react-icons/ai";
import Input from "../inputs/Input";
import { useForm } from "react-hook-form";
import { FaTrash, FaUser } from "react-icons/fa6";
import DrawerLoading from "../DrawerLoading";

const AdminAnnotationSpecific = ({ companyId, isActive }) => {
  const [isSubmittingAnnotation, setIsSubmittingAnnotation] = useState(false);
  const [errorAnnotation, setErrorAnnotation] = useState(null);

  const {
    isLoading: isLoadingAnnotations,
    error: errorAnnotations,
    data: annotations,
    refetch: refetchAnnotations,
  } = useQuery(
    ["annotations", companyId],
    async () => {
      const { data } = await axios.get(`${ADMIN.GET_ANNOTATIONS}/${companyId}`);

      return data.data;
    },
    {
      enabled: !!companyId && isActive,
    }
  );

  const {
    register: registerAnnotation,
    handleSubmit: handleSubmitAnnotation,
    reset: resetAnnotation,
    formState: { errors: errorsAnnotation },
  } = useForm();

  const onSubmitNewAnnotation = async (data) => {
    try {
      setIsSubmittingAnnotation(true);
      let bodyData = {
        companyId: companyId,
        description: data.description,
      };

      await axios.post(`${ADMIN.GET_ANNOTATION}`, bodyData);

      setErrorAnnotation(null);
      refetchAnnotations();
      resetAnnotation();
    } catch (error) {
      setErrorAnnotation(error);
      console.error(error);
    } finally {
      setIsSubmittingAnnotation(false);
    }
  };

  const onDeleteAnnotation = async (annotationId) => {
    try {
      await axios.delete(`${ADMIN.GET_ANNOTATION}/${annotationId}`);
      refetchAnnotations();
    } catch (error) {}
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-6 gap-4 items-start relative">
      {isLoadingAnnotations && <DrawerLoading />}
      <form
        className="mb-4 border border-gray-300 p-2 rounded-md col-span-2"
        onSubmit={handleSubmitAnnotation(onSubmitNewAnnotation)}
      >
        <div className="mb-2">
          <Input
            register={registerAnnotation}
            label="Descrição da anotação"
            name="description"
            required="true"
          />
        </div>
        <Button
          type="submit"
          className="w-full primary"
          isProcessing={isSubmittingAnnotation}
          processingSpinner={
            <AiOutlineLoading className="h-6 w-6 animate-spin" />
          }
          disabled={isSubmittingAnnotation}
        >
          Adicionar anotação
        </Button>
        {errorAnnotation && (
          <Alert className="mt-3" withBorderAccent color="failure">
            Erro ao tentar adicionar anotação! Tente novamente mais tarde.
          </Alert>
        )}
      </form>
      <div className="col-span-4">
        <div className="px-2 mb-3">
          <div className="font-semibold">Histórico de Anotações</div>
          <small>
            Anote e acompanhe informações importantes sobre cada cliente, tudo
            em um só lugar.
          </small>
        </div>
        {annotations?.length > 0 ? (
          <div
            className="px-6 pt-4 overflow-y-auto bg-gray-100 rounded-md shadow-sm"
            style={{ maxHeight: "400px" }}
          >
            <Timeline className="mt-6">
              {annotations?.map((annot, index) => (
                <TimelineItem key={index} className="-mt-6">
                  <TimelinePoint />
                  <TimelineContent>
                    <TimelineTime className="text-xs block  pt-1 flex justify-between">
                      <div className="text-green-600">
                        {moment(annot.createdAt).format("DD/MM/yyyy - HH:mm")}h
                      </div>
                      <button
                        className="text-xs text-red-700 flex gap-1 items-center"
                        onClick={() => onDeleteAnnotation(annot.id)}
                      >
                        <FaTrash />
                        <div>Excluir</div>
                      </button>
                    </TimelineTime>
                    <TimelineTitle className="text-base font-normal">
                      {annot.description}
                    </TimelineTitle>
                    <TimelineBody>
                      <div className="text-sm flex gap-1 items-center mt-1">
                        <FaUser fontSize={12} /> {annot?.User?.name}
                      </div>
                    </TimelineBody>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          </div>
        ) : (
          <Alert color="gray">
            Nenhum histórico de anotação para este cliente.
          </Alert>
        )}
      </div>
    </div>
  );
};

export default AdminAnnotationSpecific;
